(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xpai-products-panel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xpai-products-panel'))customElements.define('xpai-products-panel',class extends HTMLElement{
 connectedCallback(){
  this.addEventListener('click',this.onClick=e=>{
   const category=e.target.closest('[data-xpm-category]');
   const filter=e.target.closest('[data-xpm-filter]');
   const viewAll=e.target.closest('[data-xpm-view-all]');
   if(category)this.selectCategory(category.dataset.xpmCategory);
   if(filter)this.filter(filter.closest('[data-xpm-group]'),filter.dataset.xpmFilter);
   if(viewAll)this.filter(viewAll.closest('[data-xpm-group]'),'all');
  });
 }
 selectCategory(key){
  const groupKey=key==='preorders'?'outdoor':key;
  this.querySelectorAll('[data-xpm-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.xpmCategory===key)));
  this.querySelectorAll('[data-xpm-group]').forEach(g=>g.hidden=g.dataset.xpmGroup!==groupKey);
  const group=this.querySelector('[data-xpm-group="'+groupKey+'"]');
  if(group)this.filter(group,groupKey==='kits'?(group.querySelector('[data-xpm-filter]')?.dataset.xpmFilter||'all'):'all');
 }
 filter(group,key){
  group.querySelectorAll('[data-xpm-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.xpmFilter===key)));
  group.querySelectorAll('[data-xpm-card]').forEach(c=>c.hidden=key!=='all'&&c.dataset.xpmCard!==key);
  group.querySelector('[data-xpm-cards]').toggleAttribute('data-xpm-single',key!=='all');
 }
 disconnectedCallback(){this.removeEventListener('click',this.onClick);}
});
if(!customElements.get('xpai-products-navigation'))customElements.define('xpai-products-navigation',class extends HTMLElement{
 connectedCallback(){
  this.details=this.querySelector('details');this.summary=this.querySelector('summary');
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.position=()=>{this.style.setProperty('--xpm-top',this.closest('store-header').getBoundingClientRect().bottom+'px');};
  this.close=(focus=false)=>{this.details.open=false;this.summary.setAttribute('aria-expanded','false');if(focus)this.summary.focus();};
  this.open=()=>{this.position();this.details.open=true;this.summary.setAttribute('aria-expanded','true');this.closest('store-header').querySelectorAll('details.xpai-nav-disclosure[open]').forEach(d=>{if(d!==this.details)d.open=false;});};
  this.summary.addEventListener('click',e=>{e.preventDefault();this.details.open?this.close():this.open();},options);
  this.addEventListener('pointerenter',()=>{clearTimeout(this.closeTimer);if(this.dataset.trigger==='hover'&&matchMedia('(hover:hover) and (pointer:fine)').matches)this.open();},options);
  this.addEventListener('pointerleave',()=>{if(this.dataset.trigger==='hover'&&matchMedia('(hover:hover) and (pointer:fine)').matches)this.closeTimer=setTimeout(()=>this.close(),180);},options);
  this.querySelector('[data-xpm-dismiss]').addEventListener('click',()=>this.close(),options);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.details.open){e.preventDefault();this.close(true);}},options);
  document.addEventListener('click',e=>{if(!this.contains(e.target)&&this.details.open)this.close();},options);
  document.addEventListener('focusin',e=>{if(this.details.open&&!this.contains(e.target))this.close();},options);
  this.closest('store-header').querySelectorAll('.xpai-nav-item').forEach(item=>item.addEventListener('pointerenter',()=>{if(!item.contains(this))this.close();},options));
  window.addEventListener('resize',()=>{if(innerWidth<1150)this.close();else this.position();},options);
  window.addEventListener('scroll',()=>{if(this.details.open)this.position();},{...options,passive:true});
 }
 disconnectedCallback(){this.abort.abort();clearTimeout(this.closeTimer);}
});
  } catch(e) { console.error(e); }
})();

})();
